<template>
  <div class="case">
    <div class="case-product">
      <div class="case-product-content">
        <img v-lazy="product.img" alt />
        <div class="product-info">
          <div class="info-bg">
            <p class="product-title">{{ product.title }}</p>
            <p class="product-time"><span>产品分类：</span>{{ product.type }}</p>
            <p class="product-time">关注人数：<span>已有</span><em style="color: red;font-weight: bold;font-size: 20px;margin: 0 5px;">{{ product.number }}</em><span>位客户关注</span></p>

            <!-- <p class="product-content">{{ product.Content }}</p> -->
          </div>
          <p class="product-tel">联系电话：<em>17856527848</em></p>
          <el-button @click="returnPage">返回上一页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productList } from "@/config.js"
export default {
  components: {

  },
  data() {
    return {
      productList,
      pid: 0,
      product: {}
    };
  },
  created() {
    const params = this.$route.params;
    this.product = this.productList.filter(item => item.name == params.name)[0].list.filter(item => item.title == params.title)[0];
    this.product.type = params.name;
  },
  mounted() {
    /* this.loadData(); */
  },
  methods: {
    returnPage() {
      this.$router.push({
        name: 'product',
        params: {
          title: this.$route.params.name
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.product-time {
  margin-bottom: 20px;
}

.product-tel {
  margin-left: 10px;
  margin: 30px 0 30px 10px;
}

.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #14679f;

  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;

    //border: 1px solid red;
    &-content {
      width: 100%;
      /* margin: 0 auto; */
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      /* align-items: center; */
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      /* justify-content: space-between; */
      padding: 50px 0;
      margin: 0 20px;

      img {
        width: 40%;
        height: 430px;
      }

      .product-info {
        width: 40%;
        margin-left: 40px;

        .info-bg {
          background: #f7f7f7;
          margin: 10px 0 0 0;
          padding: 5px 10px;
        }

        .product-tel {
          em {
            font-size: 24px;
            font-family: Arial;
            position: absolute;
            font-weight: 700;
            color: #d41b16;
          }
        }
      }

      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }

      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>